import { takeLatest, call, put } from 'redux-saga/effects';

import { authSuccess, SIGNUP_REQUESTED, signUpSuccess, signUpFailed } from '../actionCreators/authActions';
import { appServices } from '../shared/helpers/app-services/AppServices';
import * as tokenHelper from '../shared/helpers/TokenHelper';
import { sendErrorToSentry } from '../logging';

import redirectUserToReturnPath from './sagaHelpers/redirectUserToReturnPath';

export function* signUp(action) {
  try {
    const { user, token, userTokens } = yield call(
      appServices.createUser,
      action.email,
      action.password,
      action.firstName,
      action.lastName,
      action.token,
      action.optInMarketingEmail
    );
    user.id = user.uid;
    yield call(tokenHelper.removeAuthTokens);
    yield put(signUpSuccess(action.email));
    yield call(tokenHelper.setSparkolToken, token, user.id);
    yield call(tokenHelper.setUserTokens, userTokens);
    yield put(authSuccess(user, token));
    yield redirectUserToReturnPath();
  } catch (error) {
    sendErrorToSentry(error);
    yield put(signUpFailed(error));
  }
}

function* signupSagas() {
  yield takeLatest(SIGNUP_REQUESTED, signUp);
}

export default signupSagas;
